import React from "react";

// components
import Modal from "react-bootstrap/Modal";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { removeCommas } from "@persian-tools/persian-tools";
import PlacesInput from "../../DashboardReuseAbleComponents/AddNewFiles/PlacesInput";

// styles
import styles from "./FilterModal.module.css";
import ModalStyles from "../../DashboardReuseAbleComponents/Modal.module.css";

const marks = [
  {
    value: 0,
    label: "۰",
  },
  {
    value: 200,
    label: "۲۰۰",
  },
  {
    value: 400,
    label: "۴۰۰",
  },
  {
    value: 600,
    label: "۶۰۰",
  },
  {
    value: 800,
    label: "۸۰۰",
  },
  {
    value: 1000,
    label: "۱۰۰۰",
  },
  {
    value: 1200,
    label: "۱۲۰۰",
  },
  {
    value: 1400,
    label: "۱۴۰۰+",
  },
];

function valuetext(value) {
  return `${value}`;
}

export default function FilterModal(props) {
  const handleChange = (event, newValue) => {
    props.setFilterParams(prev => {
      return { ...prev, metraj: newValue };
    });
  };

  const sellPricesHandler = event => {
    if (event.target.name === "startPrice") {
      props.setFilterParams(prev => {
        return { ...prev, startPrice: removeCommas(event.target.value) };
      });
    } else if (event.target.name === "endPrice") {
      props.setFilterParams(prev => {
        return { ...prev, endPrice: removeCommas(event.target.value) };
      });
    }
  };

  const mortajeHandler = event => {
    if (event.target.name === "startMortaje") {
      props.setFilterParams(prev => {
        return { ...prev, startMortaje: removeCommas(event.target.value) };
      });
    } else if (event.target.name === "endMortaje") {
      props.setFilterParams(prev => {
        return { ...prev, endMortaje: removeCommas(event.target.value) };
      });
    }
  };

  const rentHandler = event => {
    if (event.target.name === "startRent") {
      props.setFilterParams(prev => {
        return { ...prev, startRent: removeCommas(event.target.value) };
      });
    } else if (event.target.name === "endRent") {
      props.setFilterParams(prev => {
        return { ...prev, endRent: removeCommas(event.target.value) };
      });
    }
  };

  const addCommas = num => num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const removeNonNumeric = num => num?.toString().replace(/[^0-9]/g, "");

  return (
    <>
      <style type="text/css">
        {`
                .modal {
                    background: #3335 !important;
                }

                .modal-content {
                    border-radius: 24px;
                }

                .modal-dialog-centered {
                    justify-content: center;
                }

                .modal-header {
                    align-items: center !important;
                }

                @media only screen and (min-width: 768.98px) {
                    .modal-content {
                        width: 942px !important;
                    }
                }

                @media only screen and (max-width: 768.98px) {
                    .modal-content {
                    width: calc(100% - 1.5rem) !important;
                    }
                }
            `}
      </style>

      <Modal {...props} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton dir="rtl">
          <div className="w-100 d-flex align-items-start justify-content-between px-3">
            <div className={ModalStyles.title}>فیلتربندی</div>
          </div>
        </Modal.Header>
        <Modal.Body dir="rtl">
          <div className="w-100 d-flex flex-column align-items-center justify-content-center p-3">
            <div
              className={`w-100 d-flex align-items-center flex-column flex-md-row justify-content-center justify-content-md-between py-2 px-3 my-2 ${styles.box_border}`}>
              <div className="d-flex align-items-center justify-content-center ms-2">
                <div className={`ms-2 ${styles.box_title}`}>متراژ</div>
                <span className={`mx-1 ${styles.box_text_sm_gray}`}>از</span>
                <div className={styles.box_number}>{props.filterParams.metraj[0]?.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}</div>
                <span className={`mx-1 ${styles.box_text_sm_gray}`}>تا</span>
                <div className={styles.box_number}>{props.filterParams.metraj[1]?.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}</div>
              </div>
              <Box sx={{ width: "100%" }} className="px-md-4 px-2">
                <Slider
                  getAriaLabel={() => "Metraj range"}
                  value={props.filterParams.metraj}
                  marks={marks}
                  onChange={handleChange}
                  valueLabelDisplay="auto"
                  getAriaValueText={valuetext}
                  min={0}
                  max={1400}
                  step={10}
                />
              </Box>
            </div>

            {props.filterCardsByCategory.onSale || props.filterCardsByCategory === "onSale" ? (
              <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center mt-0 px-3 flex-wrap mt-3" dir="ltr">
                <div className={`w-100 d-flex flex-column align-items-end justify-content-center flex-wrap py-2 px-3 my-2 ${styles.box_border}`}>
                  <div className={ModalStyles.title}>: قیمت</div>
                  <div className="w-100 d-flex align-items-center justify-content-between flex-wrap">
                    <div className="d-flex align-items-end justify-content-center flex-column my-2">
                      <div className={`mb-3 me-2 ${ModalStyles.text_gray}`}>قیمت حداکثر</div>
                      <input
                        type="text"
                        name="endPrice"
                        value={addCommas(removeNonNumeric(props.filterParams?.endPrice))}
                        onChange={sellPricesHandler}
                        className={styles.modal_input}
                      />
                    </div>
                    <div className="d-flex align-items-end justify-content-center flex-column my-2">
                      <div className={`mb-3 me-2 ${ModalStyles.text_gray}`}>قیمت حداقل</div>
                      <input
                        type="text"
                        name="startPrice"
                        value={addCommas(removeNonNumeric(props.filterParams?.startPrice))}
                        onChange={sellPricesHandler}
                        className={styles.modal_input}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center mt-0 px-3 flex-wrap mt-3" dir="ltr">
                  <div className={`w-100 d-flex flex-column align-items-end justify-content-center flex-wrap py-2 px-3 my-2 ${styles.box_border}`}>
                    <div className={ModalStyles.title}>: رهن</div>
                    <div className="w-100 d-flex align-items-center justify-content-between flex-wrap">
                      <div className="d-flex align-items-end justify-content-center flex-column my-2">
                        <div className={`mb-3 me-2 ${ModalStyles.text_gray}`}>رهن حداکثر</div>
                        <input
                          type="text"
                          name="endMortaje"
                          value={addCommas(removeNonNumeric(props.filterParams?.endMortaje))}
                          onChange={mortajeHandler}
                          className={styles.modal_input}
                        />
                      </div>
                      <div className="d-flex align-items-end justify-content-center flex-column my-2">
                        <div className={`mb-3 me-2 ${ModalStyles.text_gray}`}>رهن حداقل</div>
                        <input
                          type="text"
                          name="startMortaje"
                          value={addCommas(removeNonNumeric(props.filterParams?.startMortaje))}
                          onChange={mortajeHandler}
                          className={styles.modal_input}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center mt-0 px-3 flex-wrap my-2" dir="ltr">
                  <div className={`w-100 d-flex flex-column align-items-end justify-content-center flex-wrap py-2 px-3 my-2 ${styles.box_border}`}>
                    <div className={ModalStyles.title}>: اجاره</div>
                    <div className="w-100 d-flex align-items-center justify-content-between flex-wrap">
                      <div className="d-flex align-items-end justify-content-center flex-column my-2">
                        <div className={`mb-3 me-2 ${ModalStyles.text_gray}`}>اجاره حداکثر</div>
                        <input
                          type="text"
                          name="endRent"
                          value={addCommas(removeNonNumeric(props.filterParams.endRent))}
                          onChange={rentHandler}
                          className={styles.modal_input}
                        />
                      </div>
                      <div className="d-flex align-items-end justify-content-center flex-column my-2">
                        <div className={`mb-3 me-2 ${ModalStyles.text_gray}`}>اجاره حداقل</div>
                        <input
                          type="text"
                          name="startRent"
                          value={addCommas(removeNonNumeric(props.filterParams.startRent))}
                          onChange={rentHandler}
                          className={styles.modal_input}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center mt-0 px-3 flex-wrap mt-3 text-end" dir="rtl">
              <div className="d-flex align-items-end justify-content-center flex-column my-2" dir="ltr">
                <div className={`mb-3 me-2 ${ModalStyles.text_gray}`}>کد فایل</div>
                <input className={styles.modal_input} type="text" name="fileCode" value={props.filterParams.fileCode} onChange={changeHandler} />
              </div>
              <div className="d-flex align-items-end justify-content-center flex-column my-2" dir="ltr">
                <div className={`mb-3 me-2 ${ModalStyles.text_gray}`}>تعداد اتاق</div>
                <input className={styles.modal_input} type="number" name="room" value={props.filterParams.room} onChange={changeHandler} />
              </div>
              <div className="d-flex align-items-end justify-content-center flex-column my-2" dir="ltr">
                <div className={`mb-3 me-2 ${ModalStyles.text_gray}`}>طبقه</div>
                <input className={styles.modal_input} type="number" name="floor" value={props.filterParams.floor} onChange={changeHandler} />
              </div>
              {props.placesFiles ? <></> : <PlacesInput filterModal placeName={props.filterParams.place} setDropDownsData={props.setFilterParams} />}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="w-100 d-flex justify-content-center align-items-center mb-3">
            <div className={`d-flex align-items-center justify-content-center me-3 bg-danger ${ModalStyles.filled_btn}`} onClick={deleteFilter}>
              حذف فیتلر
            </div>
            <div className={`d-flex align-items-center justify-content-center ms-3 ${ModalStyles.filled_btn}`} onClick={modalHandler}>
              اعمال فیلتر
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );

  function deleteFilter() {
    props.setFilterParams(prev => {
      return {
        place: "",
        city: "",
        metraj: [0, 300],
        room: "",
        floor: "",
        startPrice: "",
        endPrice: "",
        startMortaje: "",
        endMortaje: "",
        startRent: "",
        endRent: "",
      };
    });
    props.deleteFilterHandler();
    props?.onHide();
  }

  function changeHandler(event) {
    props.setFilterParams(prev => {
      return { ...prev, [event.target.name]: event.target.value };
    });
  }

  function modalHandler(event) {
    props.setFilterParams(prev => {
      return { ...prev, dataChanged: true, showModal: false };
    });
    props.dataHandler(undefined, 1);
    props?.onHide();
  }
}
